import React, { useState } from 'react';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const LayoutThemesTab = ({
  layoutMode,
  onLayoutChange,
  theme,
  onThemeChange,
  darkMode,
  onDarkModeToggle,
}) => {
  const [showAbout, setShowAbout] = useState(false);

  return (
    <div className="space-y-5 pt-4 min-h-[420px]">
      <div className="space-y-3">
        <div className="space-y-1">
          <Label htmlFor="layout-mode" className="text-base font-medium">Category Layout</Label>
          <p className="text-sm text-slate-500">Choose category display style</p>
        </div>
        <Select value={layoutMode} onValueChange={onLayoutChange}>
          <SelectTrigger id="layout-mode" className="h-10" data-testid="select-layout">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="side-by-side">Side-by-side</SelectItem>
            <SelectItem value="stacked">Stacked</SelectItem>
            <SelectItem value="priority-stacked">Priority Stacked</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3">
        <div className="space-y-1">
          <Label htmlFor="theme" className="text-base font-medium">Theme</Label>
          <p className="text-sm text-slate-500">Choose your visual style</p>
        </div>
        <Select value={theme} onValueChange={onThemeChange}>
          <SelectTrigger id="theme" className="h-10" data-testid="select-theme">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="prime">Prime</SelectItem>
            <SelectItem value="inkpaper">Ink & Paper</SelectItem>
            <SelectItem value="executive">Executive</SelectItem>
            <SelectItem value="frostedglass">Frosted Glass</SelectItem>
            <SelectItem value="forest">Forest Focus</SelectItem>
            <SelectItem value="ocean">Ocean Depth</SelectItem>
            <SelectItem value="floral">Spring Floral</SelectItem>
            <SelectItem value="sunset">Sunset</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center justify-between space-x-4">
        <div className="flex-1 space-y-1">
          <Label htmlFor="dark-mode" className="text-base font-medium">Dark Mode</Label>
          <p className="text-sm text-slate-500">Switch to dark background</p>
        </div>
        <Switch id="dark-mode" checked={darkMode} onCheckedChange={onDarkModeToggle} data-testid="switch-dark-mode" />
      </div>

      {/* About Section */}
      <div className="pt-4 border-t border-slate-200 dark:border-gray-700">
        <button
          onClick={() => setShowAbout(!showAbout)}
          className="w-full flex items-center justify-between text-left hover:bg-slate-50 dark:hover:bg-gray-800 p-2 rounded-lg transition-colors"
          data-testid="about-toggle"
        >
          <h3 className="text-lg font-semibold text-slate-900 dark:text-white">About</h3>
          <svg className={`w-5 h-5 text-slate-600 dark:text-gray-400 transition-transform ${showAbout ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {showAbout && (
          <div className="mt-3 space-y-2 text-sm text-slate-600 dark:text-gray-400 pl-2">
            <div className="flex justify-between items-center">
              <span className="font-medium">Version:</span>
              <span className="text-slate-900 dark:text-white">9.28</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="font-medium">Copyright:</span>
              <span className="text-slate-900 dark:text-white">&copy; 2026 Robert Farrah</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="font-medium">Notes:</span>
              <a href="/notes" className="text-blue-600 dark:text-blue-400 hover:underline" data-testid="settings-notes-link">taskpriority.net/notes</a>
            </div>
            <div className="flex justify-between items-center">
              <span className="font-medium">Privacy Policy:</span>
              <a href="/privacy" className="text-blue-600 dark:text-blue-400 hover:underline" data-testid="settings-privacy-link">taskpriority.net/privacy</a>
            </div>
            <div className="flex justify-between items-center">
              <span className="font-medium">Terms of Service:</span>
              <a href="/terms" className="text-blue-600 dark:text-blue-400 hover:underline" data-testid="settings-terms-link">taskpriority.net/terms</a>
            </div>
            <div className="flex flex-col space-y-1">
              <span className="font-medium">Contact:</span>
              <a href="mailto:rpfarrah@gmail.com" className="text-blue-600 dark:text-blue-400 hover:underline">rpfarrah@gmail.com</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutThemesTab;
